
import {types} from '../types/types';

const initialState = {
  editingDevice: { },
  availableDevices: [] // ← aquí está el error
};

export const deviceReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.editingDeviceInfo:
            return {
                ...state,
                editingDevice: action.payload,
            };

        case types.clearDeviceInfo:
            return {
                ...state,
                editingDevice: initialState.editingDevice,
            };
        case types.setAvailableDevices:
            return {
                ...state,
                availableDevices: action.payload
            };

        default:
            return state;
    }
};